// shared tooltip UX rules
const tooltipUXProps = {
  enterNextDelay: 250,
};

export default tooltipUXProps;
